export const userVenuesBuilderForUI = venue => ({
  id: venue.id,
  venueId: venue.venue_id,
  image: venue.image_filename,
  name: venue.name,
  isShow: false,
});
